import React from 'react';
import { NextSeo } from 'next-seo';
import { useUserAgent } from 'next-useragent';
import { RootStoreProvider } from '../providers/RootStoreProvider';
import { Layout } from '../components/Layout';
import { Page503 } from '../components/ErrorPage/503';
import { SearchStoreProvider } from '../providers/SearchStoreProvider';

export default function Custom503({ uaString }) {
  const ua = useUserAgent(uaString);
  const {isMobile, isTablet} = ua;
  return (
    <SearchStoreProvider>
      <RootStoreProvider>
        <NextSeo title={'Ошибка 503: страница не доступна'}/>
        <Layout isMobile={isMobile} isTablet={isTablet} isOutsPage>
          <Page503 />
        </Layout>
      </RootStoreProvider>
    </SearchStoreProvider>
  );
}
